import apollo from '@/graphql'

import cache from '@/store/helpers/cache.helper'

import CustomerTrafficQuery from '@/graphql/metrics/CustomerTrafficQuery.gql'
import CustomerTrafficLastSevenDaysQuery from '@/graphql/metrics/CustomerTrafficLastSevenDaysQuery.gql'

const state = {
  customerTraffic: {},
  customerTrafficLastSevenDays: [],
  isCustomerTrafficLoading: true,
  isCustomerTrafficLastSevenDaysLoading: true,
}

const getters = {
  //
}

const mutations = {
  initializeStore() {
    state.customerTraffic = cache.get('customerTraffic') || {}
    state.customerTrafficLastSevenDays = cache.get('customerTrafficLastSevenDays') || []
  },

  setCustomerTraffic(st, customerTraffic) {
    cache.set('customerTraffic', customerTraffic)
    state.customerTraffic = customerTraffic
  },

  setCustomerTrafficLastSevenDays(state, customerTrafficLastSevenDays) {
    cache.set('customerTrafficLastSevenDays', customerTrafficLastSevenDays)
    state.customerTrafficLastSevenDays = customerTrafficLastSevenDays
  },

  setCustomerTrafficLoading(state, loading) {
    state.isCustomerTrafficLoading = loading
  },

  setCustomerTrafficLastSevenDaysLoading(state, loading) {
    state.isCustomerTrafficLastSevenDaysLoading = loading
  },
}

const actions = {
  init({ commit }) {
    commit('initializeStore')
  },

  async loadCustomerTrafficData({ commit }, { refreshCache }) {
    if (!cache.get('customerTraffic')) {
      commit('setCustomerTrafficLoading', true)
    }

    const { data: { customerTraffic } } = await apollo.defaultClient.query({
      query: CustomerTrafficQuery,
      fetchPolicy: refreshCache ? 'network-only' : 'cache-first',
    })

    commit('setCustomerTrafficLoading', false)
    commit('setCustomerTraffic', customerTraffic)
  },

  async loadCustomerTrafficDataLastSevenDays({ commit }, { refreshCache }) {
    if (!cache.get('customerTrafficLastSevenDays')) {
      commit('setCustomerTrafficLastSevenDaysLoading', true)
    }

    const { data: { customerTrafficLastSevenDays } } = await apollo.defaultClient.query({
      query: CustomerTrafficLastSevenDaysQuery,
      fetchPolicy: refreshCache ? 'network-only' : 'cache-first',
    })

    commit('setCustomerTrafficLastSevenDaysLoading', false)
    commit('setCustomerTrafficLastSevenDays', customerTrafficLastSevenDays)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/metrics/CustomerTraffic.js